import { useMutation, useQueryClient } from '@tanstack/react-query';
import { offerPeriodInquiry, offerVersionEndpoints } from '@ooh/contracts';
import type { OfferPeriodInquiryUnitSelection, UnitDecisionEntry } from '@ooh/contracts';
import { apiQueryKey } from '../../../data/use-api-suspense-query';
import { useApiClient } from '../../../plugs/api-client';

export interface AcceptVersionVars {
  offerId: string;
  versionId: string;
  unitDecisions?: UnitDecisionEntry[];
}

export function useAcceptVersion() {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ offerId, versionId, unitDecisions }: AcceptVersionVars) =>
      api.call(offerVersionEndpoints.accept, {
        id: Number(offerId),
        versionId: Number(versionId),
        unitDecisions,
      }),
    onSuccess: async (_data, { offerId }) => {
      await queryClient.invalidateQueries({
        queryKey: apiQueryKey(offerVersionEndpoints.clientView, { id: Number(offerId) }),
        exact: true,
      });
    },
    // A hook-level onError, even a no-op, makes the web MutationCache skip its generic toast;
    // the caller shows the specific 409 message instead.
    onError: () => {},
  });
}

export interface SubmitPeriodInquiryVars {
  offerId: string;
  selection: OfferPeriodInquiryUnitSelection[];
}

export function useSubmitPeriodInquiry() {
  const api = useApiClient();
  return useMutation({
    mutationFn: ({ offerId, selection }: SubmitPeriodInquiryVars) =>
      api.call(offerPeriodInquiry.submit, { id: Number(offerId), selection }),
  });
}
